import Label from "../Label";
import Select from "../Select";
import { INITIAL_INSTALLMENTS_MAX, clampInitialInstallments } from "../../../utils/initialInstallments";

interface InitialInstallmentSelectProps {
    maxInstallments: number;
    value: string;
    onChange: (value: string) => void;
}

export default function InitialInstallmentSelect({ maxInstallments, value, onChange }: InitialInstallmentSelectProps) {
    const options = [
        { value: INITIAL_INSTALLMENTS_MAX, label: `Maior parcela disponível (até ${maxInstallments}x) — padrão` },
        ...Array.from({ length: maxInstallments - 1 }, (_, i) => {
            const n = i + 1;
            return { value: String(n), label: n === 1 ? "À vista (1x)" : `${n}x` };
        }),
    ];

    return (
        <div>
            <Label>Parcela exibida ao abrir o checkout</Label>
            <Select
                options={options}
                placeholder="Selecione uma opção"
                onChange={onChange}
                value={clampInitialInstallments(value, maxInstallments)}
            />
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Em produtos de ticket baixo, abrir em "À vista" costuma converter melhor. O comprador ainda pode escolher outra parcela.
            </p>
        </div>
    );
}
